module.exports = __webpack_public_path__ + "img/icon (1).5156d43d.png";